import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as moment from 'moment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportService } from '../report.service';
import { Location } from '@angular/common';   // <-- NEW

function marksValidator(maxMarks: number, passMarks: number) {
  return (control: FormControl): { [key: string]: any } | null => {
    const val = control.value;
    if (val === null || val === '' || val === undefined) {
      return null;
    }
    const num = Number(val);
    if (isNaN(num)) return { invalidNumber: true };
    if (num > maxMarks) return { max: true };
    if (num < passMarks) return { belowPass: true };
    return null;
  };
}

@Component({
  selector: 'app-practical-marks',
  templateUrl: './practical-markentry.component.html',
  styleUrls: ['./practical-markentry.component.scss']
})
export class PracticalMarksComponent implements OnInit {
  PracticalMarksForm: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  userPermission: any;
  Table = false;
  UpdateBtn = false;
  isBranch = false;
  filteredListBranch: any[];
  filteredsubjectList: any[];
  filteredListExam: any[];
  collegeList: any;
  filteredCollegeList: any;
  closeMessage: string;
  message: string;
  finalPayload: any[] = [];
  HeadList: any;
  examList: any[];
  CourseList: any;
  filteredListCourse: any;
  subjectList = [];
  emid: number;
  dialogRef: MatDialogRef<any>;
  BranchList: any;
  filteredListHead: any[];
  headcode: any;
  pracEsId: any;
  assignTableData: any[];
  StuArray: FormArray;
  errMsg: any;
  currentDate: Date;
  updateDisable: boolean;
  utp: string;
  formativeASSCreate = true;
  formativeASSUpdate = true;
  dynamicHeads = [];
  setIntervalSearch: any;
  subcode: string;
  statusList: any[];
  filteredStatusList: any[];
  allMarksNull: boolean;

  ecIdList: any[];
  filteredEcIdList: any[];
  showEcIdDropdown = false;
  selectedEcId: number;
  RGInCode = 7;

  ecIdFetched = false;
  ecIdErrorMessage = '';
  ecIdEmpty = false;
  hasExistingMarks: boolean = false;

  isFinalizing: boolean = false;
  isFinal: boolean = false;

  panelList: any[] = [];
  filteredPanelList: any[] = [];
  showPanelDropdown = false;
  isPanelSaved = false;
  panelSaveDisabled = false;
  selectedPanel: number = 0;
  parentSubjectId: number = 0;
  batchNoId: number = 0;
  panelTeacherTooltips: string[] = [];
  panelTeacherDetails: any[][] = [];
  private routeParams: any = {};
  private autoSelectMode: boolean = false;
  private autoSelectBatchName: string = '';

  constructor(
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private router: Router,
    private reportService: ReportService,
    private route: ActivatedRoute,
    private location: Location                       // <-- NEW
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.Table = false;
    this.UpdateBtn = false;
    this.isBranch = false;
    this.updateDisable = false;
    this.showEcIdDropdown = false;
    this.ecIdFetched = false;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    this.hasExistingMarks = false;
    this.isFinalizing = false;
    this.isFinal = false;

    this.PracticalMarksForm = this.fb.group({
      college: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      SessionId: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      SubCode: new FormControl(''),
      EsId: new FormControl('', Validators.required),
      Branch: new FormControl(''),
      EsParentId: new FormControl('', Validators.required),
      EcId: new FormControl(''),
      StuArray: new FormArray([]),
      SearchString: new FormControl(''),
      SelectedPanel: new FormControl('')
    });

    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Practical Marks' && element.PCreate == false) {
          this.formativeASSCreate = false;
        }
        if (element.PageName == 'Practical Marks' && element.PUpdate == false) {
          this.formativeASSUpdate = false;
        }
      });
    }

    this.route.queryParams.subscribe(params => {
      this.routeParams = params || {};
      if (this.routeParams['SessionId']) {
        this.autoSelectMode = true;
      }
      if (this.routeParams['BatchName']) {
        this.autoSelectBatchName = this.routeParams['BatchName'];
      }
    });

    this.fetchSession();
    this.fetchStatus();
    this.currentDate = new Date();
  }

  // <-- NEW: go back to the previous page
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      // Fallback if there is no history — go to dashboard
      this.router.navigate(['/HomePage']);
    }
  }

  getStuArrayControls() {
    return (this.PracticalMarksForm.get('StuArray') as FormArray).controls;
  }

  fetchSession() {
    this.spinner.show();
    const payload = { SnDefault: '', SnNo: '' };
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
        this.tryAutoSelectSession();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    });
  }

  getCourse(data) {
    this.spinner.show();
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.isBranch = false;
    this.showEcIdDropdown = false;
    this.ecIdFetched = false;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    this.hasExistingMarks = false;
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];

    this.resetPanelState();

    const payload = { SessionId: data };
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.tryAutoSelectCourse();
      } else {
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    });
  }

  getCollege(item) {
    this.spinner.show();
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.showEcIdDropdown = false;
    this.ecIdFetched = false;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    this.hasExistingMarks = false;
    this.filteredsubjectList = [];
    this.filteredListExam = [];

    this.resetPanelState();

    if (!this.autoSelectMode) {
      this.getExamList(item);
    }

    const payload = { CoCode: item.CoCode };
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();

      if (this.autoSelectMode) {
        this.tryAutoSelectCollege(item);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    });
  }

  getExamList(item) {
    this.spinner.show();
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.filteredsubjectList = [];
    this.isBranch = false;
    this.showEcIdDropdown = false;
    this.ecIdFetched = false;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    this.hasExistingMarks = false;

    this.resetPanelState();

    const payload = { EmCoCode: item.CoCode };
    this.umsService.getExam(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
        this.tryAutoSelectExam();
      } else {
        let data = {
          message: res.message,
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {
        message: ERROR.error.message,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getSubject(e) {
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.isBranch = false;
    this.showEcIdDropdown = false;
    this.ecIdFetched = false;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    this.hasExistingMarks = false;
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = [];
    this.emid = e.EmId;

    this.resetPanelState();

    this.fetchEcIdList();

    if (e.EmStreams == "Y") {
      this.isBranch = true;
      this.fetchBranch(e.EmId);
    } else {
      this.spinner.show();
      this.isBranch = false;
      const payload = { EsEmId: e.EmId, EsStrId: 0 };
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element);
          } else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub);
            });
          }
        });
        this.filteredsubjectList = this.subjectList.slice();
        this.tryAutoSelectSubject();
      });
    }
  }

  fetchEcIdList() {
    this.ecIdFetched = true;
    this.ecIdErrorMessage = '';
    this.ecIdEmpty = false;
    const payload2 = this.PracticalMarksForm.value;

    const payload = {
      SnNo: payload2.SessionId,
      InCode: this.RGInCode,
      OpId: parseInt(sessionStorage.getItem('userId')),
      Emid: payload2.EmId,
    };
    this.umsService.getExmFrmDrpList(payload).subscribe(res => {
      if (res.status && res.data && res.data.length > 0) {
        this.ecIdList = res.data.filter((it) => it.EmId === payload.Emid);
        this.filteredEcIdList = this.ecIdList.slice();
        if (this.ecIdList.length > 0) {
          this.showEcIdDropdown = true;
          this.ecIdEmpty = false;
        } else {
          this.showEcIdDropdown = false;
          this.ecIdEmpty = true;
          this.ecIdErrorMessage = 'No exam control list available for this exam.';
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: this.ecIdErrorMessage,
            title: 'Information',
            icon: 'fas fa-info-circle'
          });
        }
      } else {
        this.ecIdList = [];
        this.filteredEcIdList = [];
        this.showEcIdDropdown = false;
        this.ecIdEmpty = true;
        this.ecIdErrorMessage = 'No exam control list available for this exam.';
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: this.ecIdErrorMessage,
          title: 'Information',
          icon: 'fas fa-info-circle'
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.ecIdList = [];
      this.filteredEcIdList = [];
      this.showEcIdDropdown = false;
      this.ecIdEmpty = true;
      this.ecIdErrorMessage = 'Error fetching exam control list. Please try again.';
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: this.ecIdErrorMessage,
        title: 'Error',
        icon: 'fas fa-close'
      });
    });
  }

  onEcIdSelect(item) {
    this.selectedEcId = item.EcId;
    this.PracticalMarksForm.controls['EcId'].setValue(item.EcId);
  }

  fetchBranch(id) {
    this.spinner.show();
    const payload = { EmId: id };
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
        this.tryAutoSelectBranch();
      }
    });
  }

  getStr(e) {
    this.spinner.show();
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.filteredsubjectList = [];
    this.subjectList = [];

    this.resetPanelState();

    let payload = {
      EsEmId: this.emid,
      EsStrId: this.PracticalMarksForm.value.Branch
    };

    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element);
          } else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub);
            });
          }
        });
        this.filteredsubjectList = this.subjectList.slice();
        this.tryAutoSelectSubject();
      } else {
        this.subjectList = [];
        this.filteredsubjectList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  subjectClick(data) {
    this.spinner.show();
    this.HeadList = [];
    this.filteredListHead = [];
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;
    this.subcode = data.EsCode;

    this.StuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [];
    this.dynamicHeads = [];
    this.hasExistingMarks = false;
    this.isFinal = false;
    this.PracticalMarksForm.controls['EsId'].setValue('');

    this.parentSubjectId = (data.EsPSubId && data.EsPSubId !== 0) ? data.EsPSubId : data.EsId;
    this.PracticalMarksForm.controls['EsParentId'].setValue(this.parentSubjectId);

    this.resetPanelState(false);
    this.fetchPanelsForBatch();

    let payload2 = this.PracticalMarksForm.value;
    const payload = {
      PtSnNo: payload2.SessionId,
      PtCoCode: payload2.course,
      PtEsCode: this.subcode,
      PtEmId: payload2.EmId,
      PtCgCode: payload2.college,
      PtStrId: payload2.Branch ? payload2.Branch : "0"
    };

    this.umsService.getPracticalBatches(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.HeadList = res.data;
        this.filteredListHead = this.HeadList.slice();
        this.tryAutoSelectBatch();
      } else {
        let data = {
          message: 'No Batches Found',
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.HeadList = [];
        this.PracticalMarksForm.controls['EsId'].setValue('');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {
        message: 'No Batches Found',
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.HeadList = [];
      this.PracticalMarksForm.controls['EsId'].setValue('');
    });
  }

  getHeadCode(data) {
    this.headcode = data.PbdBatchName;
    this.batchNoId = data.PbdBatchNo;
    this.pracEsId = data.PtEsId;
    this.Table = false;
    this.UpdateBtn = false;
    this.allMarksNull = true;

    this.PracticalMarksForm.controls['EsId'].setValue(data.PbdBatchName);

    this.resetPanelState(false);
    this.fetchSavedPanelForBatch(true);
  }

  resetPanelState(resetPanels: boolean = true) {
    this.isPanelSaved = false;
    this.panelSaveDisabled = false;
    this.selectedPanel = 0;
    this.PracticalMarksForm.patchValue({ SelectedPanel: '' });
    if (resetPanels) {
      this.showPanelDropdown = false;
      this.panelList = [];
      this.filteredPanelList = [];
      this.parentSubjectId = 0;
      this.batchNoId = 0;
    }
  }

  fetchPanelsForBatch() {
    const formVal = this.PracticalMarksForm.value;
    if (!formVal.SessionId || !formVal.course || !formVal.EmId || !formVal.college || !this.parentSubjectId) {
      return;
    }

    this.spinner.show();
    const payload = {
      SessionNo: formVal.SessionId,
      CoCode: formVal.course,
      EmId: formVal.EmId,
      CgCode: formVal.college,
      EsId: this.parentSubjectId
    };

    this.umsService.getPanelAssignments(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data && res.data.length) {
        const uniquePanels = new Map();
        res.data.forEach(item => {
          const panelNo = item.PanelNo;
          if (panelNo && !uniquePanels.has(panelNo)) {
            let tooltipText = '';
            let teachersArray: any[] = [];
            if (item.Teachers) {
              try {
                teachersArray = typeof item.Teachers === 'string'
                  ? JSON.parse(item.Teachers)
                  : item.Teachers;
                if (Array.isArray(teachersArray) && teachersArray.length) {
                  tooltipText = teachersArray.map(t =>
                    `• ${t.TeacherName}${t.Designation ? ` (${t.Designation})` : ''}`
                  ).join('\n');
                  console.log(JSON.stringify(tooltipText));
                } else {
                  tooltipText = 'No teachers assigned';
                }
              } catch (e) {
                tooltipText = 'Invalid teacher data';
                teachersArray = [];
              }
            } else {
              tooltipText = 'No teachers assigned';
            }
            uniquePanels.set(panelNo, {
              PanelId: panelNo,
              PanelName: `Examiner Panel ${panelNo}`,
              TeacherTooltip: tooltipText,
              TeacherDetails: teachersArray
            });
          }
        });
        this.panelList = Array.from(uniquePanels.values());
        this.filteredPanelList = [...this.panelList];
        this.panelTeacherTooltips = this.panelList.map(p => p.TeacherTooltip);
        this.panelTeacherDetails = this.panelList.map(p => p.TeacherDetails);
        this.showPanelDropdown = true;
      } else {
        this.showPanelDropdown = false;
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'No panels scheduled for this subject and center. Please schedule panels first using "Assign Panel Dates" before entering marks.',
          title: 'Information',
          icon: 'fas fa-info-circle'
        });
      }
    }, err => {
      this.spinner.hide();
      this.showPanelDropdown = false;
      console.error('Error fetching panels:', err);
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Error fetching panel data. Please try again later.',
        title: 'Error',
        icon: 'fas fa-close'
      });
    });
  }

  fetchSavedPanelForBatch(showTableIfSaved: boolean = false) {
    const formVal = this.PracticalMarksForm.value;
    if (!formVal.SessionId || !formVal.course || !formVal.EmId || !this.batchNoId || !this.parentSubjectId) {
      return;
    }

    this.spinner.show();
    const payload = {
      SessionId: formVal.SessionId,
      CoCode: formVal.course,
      EmId: formVal.EmId,
      CgCode: formVal.college,
      BatchNo: this.batchNoId,
      EsId: this.parentSubjectId
    };

    this.umsService.getSavedPanelForBatch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data && res.data.PanelId) {
        const panelId = Number(res.data.PanelId);
        if (!this.panelList.some(p => p.PanelId === panelId)) {
          this.panelList.push({
            PanelId: panelId,
            PanelName: `Examiner Panel ${panelId}`,
            TeacherTooltip: 'Saved panel',
            TeacherDetails: []
          });
          this.filteredPanelList = [...this.panelList];
        }

        this.isPanelSaved = true;
        this.panelSaveDisabled = true;
        this.selectedPanel = panelId;
        this.PracticalMarksForm.patchValue({ SelectedPanel: panelId });
        if (showTableIfSaved) {
          this.ShowTable();
        }
      } else {
        this.isPanelSaved = false;
        this.panelSaveDisabled = false;
        this.selectedPanel = 0;
        this.PracticalMarksForm.patchValue({ SelectedPanel: '' });
      }
    }, err => {
      this.spinner.hide();
      console.error('Error fetching saved panel:', err);
    });
  }

  savePanel() {
    if (this.isPanelSaved) return;
    const selectedPanel = this.PracticalMarksForm.value.SelectedPanel;
    if (!selectedPanel) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Please select a panel before saving.',
        title: 'Alert',
        icon: 'fas fa-close'
      });
      return;
    }

    const confirmData: any = {
      message: "Are you sure you want to save this panel for this batch? This is a one-time process and cannot be changed later.",
      title: "Confirm Save",
      icon: "fa fa-question",
    };
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, confirmData);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === "yes") {
        this.submitPanelSave();
      }
    });
  }

  submitPanelSave() {
    this.spinner.show();
    const formVal = this.PracticalMarksForm.value;
    const selectedPanel = formVal.SelectedPanel;

    const payload = {
      SessionId: formVal.SessionId,
      CoCode: formVal.course,
      EmId: formVal.EmId,
      CgCode: formVal.college,
      BatchNo: this.batchNoId,
      EsId: this.parentSubjectId,
      PanelId: selectedPanel,
      LoginId: parseInt(sessionStorage.getItem('userId'))
    };

    this.umsService.savePracticalPanel(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.isPanelSaved = true;
        this.panelSaveDisabled = true;
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: 'Panel saved successfully for this batch.',
          title: 'Success',
          icon: 'fas fa-check'
        });
        this.ShowTable();
      } else {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: res.message || 'Failed to save panel.',
          title: 'Error',
          icon: 'fas fa-close'
        });
      }
    }, err => {
      this.spinner.hide();
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: err.error?.message || 'Network error while saving panel.',
        title: 'Error',
        icon: 'fas fa-close'
      });
    });
  }

  ShowTable() {
    this.spinner.show();
    this.Table = false;
    let payload2 = this.PracticalMarksForm.value;
    this.StuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [];

    const payload = {
      PtSnNo: payload2.SessionId,
      PtCoCode: payload2.course,
      PtEsId: this.pracEsId,
      PbdBatchNo: this.headcode,
      PtCgCode: payload2.college,
      PtEmId: payload2.EmId,
      PtStrId: payload2.Branch ? payload2.Branch : "0",
      EcId: payload2.EcId || null
    };

    this.umsService.getPracMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const groupedData = [];
        const tempMap = new Map();

        res.data.forEach(item => {
          if (!tempMap.has(item.StuId)) {
            const { ParentSubCode, PrMarks, PrMarksStatus, PrStudentStatus, ...studentData } = item;
            tempMap.set(item.StuId, {
              ...studentData,
              marks: {}
            });
          }

          const student = tempMap.get(item.StuId);
          student.marks[item.ParentSubCode] = {
            Marks: item.PrMarks == 0 ? 0 : item.PrMarks,
            Status: item.PrStudentStatus || '',
            StuPrMarksId: item.StuPrMarksId,
            EsId: item.EsId
          };
        });

        tempMap.forEach(value => groupedData.push(value));
        this.assignTableData = groupedData;

        this.dynamicHeads = [];
        res.data.forEach(item => {
          if (!this.dynamicHeads.find(h => h.code === item.ParentSubCode)) {
            this.dynamicHeads.push({
              code: item.ParentSubCode,
              label: item.ParentSubName,
              maxmarks: item.EsMaxMarks,
              passmarks: item.EsPassMarks,
              subcode: item.SubCode,
              type: 'marks'
            });
          }
        });

        this.Table = true;

        this.hasExistingMarks = this.assignTableData.some(student =>
          this.dynamicHeads.some(head =>
            student.marks[head.code]?.StuPrMarksId !== null &&
            student.marks[head.code]?.StuPrMarksId !== undefined &&
            student.marks[head.code]?.StuPrMarksId !== 0
          )
        );

        if (this.ecIdEmpty) {
          this.UpdateBtn = false;
        } else {
          this.UpdateBtn = res.data[0].IsFinal !== 'Y';
        }

        this.isFinal = res.data[0].IsFinal === 'Y';

        const allMarksNull = this.assignTableData.every(item => {
          return this.dynamicHeads.every(head => {
            const markValue = item.marks[head.code]?.Marks;
            return markValue === null || markValue === '' || markValue === undefined;
          });
        });

        this.allMarksNull = allMarksNull;

        const defaultStatusCode = (this.statusList && this.statusList.length)
          ? this.statusList[0].CdCode
          : '';

        this.assignTableData.forEach((element) => {
          const creds = this.PracticalMarksForm.get('StuArray') as FormArray;
          const marksGroup = this.fb.group({});

          this.dynamicHeads.forEach(head => {
            const defaultValue = element.marks[head.code]?.Marks ?? '';
            const statusValue = element.marks[head.code]?.Status ?? '';

            const markControl = new FormControl(
              { value: defaultValue, disabled: this.ecIdEmpty },
              Validators.required
            );
            const statusControl = new FormControl(
              { value: statusValue, disabled: this.ecIdEmpty }
            );
            const idControl = new FormControl(
              { value: element.marks[head.code]?.StuPrMarksId || null, disabled: this.ecIdEmpty }
            );
            const ptIdControl = new FormControl(
              { value: element['PtId'], disabled: this.ecIdEmpty }
            );

            marksGroup.addControl(head.code, markControl);
            marksGroup.addControl(`${head.code}_Status`, statusControl);
            marksGroup.addControl(`${head.code}_StuPrMarksId`, idControl);
            marksGroup.addControl(`${head.code}_PtId`, ptIdControl);
          });

          let initialCommonStatus = '';
          if (this.dynamicHeads.length > 0) {
            const firstHead = this.dynamicHeads[0];
            initialCommonStatus = element.marks[firstHead.code]?.Status || '';
          }

          if (!initialCommonStatus && defaultStatusCode) {
            initialCommonStatus = defaultStatusCode;
          }

          creds.push(
            this.fb.group({
              PbdBatchName: new FormControl(element['PbdBatchName']),
              PbdBatchNo: new FormControl(element['PbdBatchNo']),
              Name: new FormControl(element['StuFirstNameEng']),
              StuId: new FormControl(element['StuId']),
              commonStatus: new FormControl({ value: initialCommonStatus, disabled: this.ecIdEmpty }),
              marks: marksGroup
            })
          );
        });

        this.getSessionCutOff();
      } else {
        this.assignTableData = [];
        this.UpdateBtn = false;
        this.hasExistingMarks = false;
        this.isFinal = false;
        let data = {
          message: 'No Data Found',
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getSessionCutOff();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.getSessionCutOff();
      this.spinner.hide();
      this.assignTableData = [];
      this.UpdateBtn = false;
      this.hasExistingMarks = false;
      this.isFinal = false;
      let data = {
        message: ERROR.error.message,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getSessionCutOff() {
    this.spinner.show();
    let payload2 = this.PracticalMarksForm.value;
    const payload = {
      SessionID: payload2.SessionId,
      CoCgCgCode: payload2.college,
      CoCgCoCode: payload2.course,
      InCode: 'PrMar',
      EmId: payload2.EmId
    };

    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const data = res.data[res.data.length - 1];
        if (data && data.CutOffDateFrom && data.CutOffDate) {
          const toDateOnly = (date: Date): Date => {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
          };

          const cutOffDateFrom = new Date(data.CutOffDateFrom);
          const cutOffDate = new Date(data.CutOffDate);
          const currentDate = new Date();
          const startDate = toDateOnly(cutOffDateFrom);
          const endDate = toDateOnly(cutOffDate);
          const today = toDateOnly(currentDate);

          if (today >= startDate && today <= endDate) {
            this.message = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')}`;
          } else {
            this.closeMessage = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')} now session is closed`;
          }
        }
      } else {
        this.closeMessage = 'The session cutoff has not been added.';
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.closeMessage = 'The session cutoff has not been added.';
    });
  }

  update() {
    this.updatePracticalMarks();
  }

  updatePracticalMarks() {
    this.spinner.show();
    const submitpayload = this.PracticalMarksForm.value;
    this.finalPayload = [];
    this.StuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    const students = this.StuArray.value;

    students.forEach(student => {
      const commonStatus = student.commonStatus;

      this.dynamicHeads.forEach(head => {
        const rawMarks = student.marks[head.code];
        const stuPrMarksId = student.marks[`${head.code}_StuPrMarksId`];
        const ptId = student.marks[`${head.code}_PtId`];

        const subjectEsId = this.assignTableData.find(item =>
          item.marks[head.code]
        )?.marks[head.code]?.EsId || this.pracEsId;

        let prMarks: any = null;
        let prMarksStatus = 'F';
        let prStudentStatus = '';

        if (commonStatus === 'AB') {
          prMarks = 0;
          prMarksStatus = 'F';
          prStudentStatus = 'AB';
        } else {
          if (rawMarks !== null && rawMarks !== undefined && rawMarks !== '') {
            const num = Number(rawMarks);
            if (!isNaN(num)) {
              prMarks = num;
            } else {
              prMarks = null;
            }
          } else {
            prMarks = null;
          }

          prStudentStatus = '';
          if (prMarks !== null && prMarks >= head.passmarks && prMarks <= head.maxmarks) {
            prMarksStatus = 'P';
          } else {
            prMarksStatus = 'F';
          }
        }

        let payload = {
          StuPrMarksId: stuPrMarksId,
          PtId: ptId,
          PbdBatchNo: student.PbdBatchNo,
          StuId: student.StuId,
          SessionID: submitpayload.SessionId,
          CgCode: submitpayload.college,
          EmId: submitpayload.EmId,
          CoCode: submitpayload.course,
          EsId: subjectEsId,
          SubCode: head.subcode,
          HeadCode: head.code,
          EsParentId: submitpayload.EsParentId,
          PrMarks: prMarks,
          PrMarksStatus: prMarksStatus,
          PrStudentStatus: prStudentStatus,
          IsFinal: 'N',
          EcId: submitpayload.EcId || null,
          EntryDateTime: this.currentDate,
          UpdateDateTime: new Date()
        };

        this.finalPayload.push(payload);
      });
    });

    const hasExistingRecords = this.finalPayload.some(p => p.StuPrMarksId);

    const payloadData = {
      PracticalMarks: JSON.stringify(this.finalPayload),
      LoginId: parseInt(sessionStorage.getItem('userId'))
    };

    const serviceCall = hasExistingRecords
      ? this.umsService.updateStuPracMarks(payloadData)
      : this.umsService.addStuPracMarks(payloadData);

    serviceCall.subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        if (this.isFinalizing) {
          this.isFinalizing = false;
          this.SubmitFinal();
        } else {
          let data = {
            message: res.message || "Updated Successfully",
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(() => {
            this.ShowTable();
          });
        }
      } else {
        this.isFinalizing = false;
        let data = {
          message: res.message || 'Update failed',
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.isFinalizing = false;
      let data = {
        message: ERROR.error.message,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  SaveFinal() {
    if (this.PracticalMarksForm.invalid) {
      this.PracticalMarksForm.markAllAsTouched();
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: "Please fill in all required marks before final submission.",
        title: "Validation Error",
        icon: "fas fa-exclamation-triangle"
      });
      return;
    }

    const data: any = {
      message: "Are you sure you want to make your final submission for Practical marks? You won't be able to make any changes afterward.",
      title: "Alert",
      icon: "fa fa-question",
    };

    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === "yes") {
        this.isFinalizing = true;
        this.updatePracticalMarks();
      }
    });
  }

  SubmitFinal() {
    if (this.PracticalMarksForm.invalid) {
      this.PracticalMarksForm.markAllAsTouched();
      return;
    }

    const submitpayload = this.PracticalMarksForm.value;
    const payload: any = {
      SessionID: submitpayload.SessionId,
      CoCode: submitpayload.course,
      CgCode: submitpayload.college,
      EmId: submitpayload.EmId,
      EsParentId: submitpayload.EsParentId,
      HeadCode: this.headcode,
      IsFinal: "Y",
      EcId: submitpayload.EcId || null,
      LoginId: parseInt(sessionStorage.getItem('userId'))
    };

    this.spinner.show();
    this.umsService.saveFinalPracMark(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const data = {
          message: res.message || "Final Submit Successfully",
          title: "Information",
          icon: "fas fa-check",
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.ShowTable();
        });
      } else {
        this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
          message: res.message || "Failed to submit final practical marks.",
          title: "Error",
          icon: "fas fa-times",
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: ERROR.error.message || "Failed to submit final practical marks.",
        title: "Error",
        icon: "fas fa-times",
      });
    });
  }

  onInputChange(event: any, studentIndex: number, headCode: string, headMaxMarks: number): void {
    const input = event.target;
    let value = input.value;
    value = value.replace(/[^0-9]/g, '');
    input.value = value;

    const enteredValue = value.trim();
    const stuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;

    if (enteredValue === '') {
      marksGroup.get(headCode)?.setValue(null);
      return;
    }

    const marks = Number(enteredValue);

    if (marks > headMaxMarks) {
      const data = {
        message: `Marks cannot be greater than ${headMaxMarks}`,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        input.value = '';
        marksGroup.get(headCode)?.setValue(null);
      });
      return;
    }

    if (isNaN(marks) || marks < 0) {
      marksGroup.get(headCode)?.setValue(null);
      return;
    }

    marksGroup.get(headCode)?.setValue(marks);
  }

  onCommonStatusChange(selectedStatus: string, studentIndex: number): void {
    const stuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;

    this.dynamicHeads.forEach(head => {
      const statusControl = marksGroup.get(head.code + '_Status');
      const markControl = marksGroup.get(head.code);

      if (selectedStatus === 'AB') {
        statusControl?.setValue('AB');
        markControl?.clearValidators();
        markControl?.setValue(null);
        markControl?.disable({ emitEvent: false });
      } else {
        statusControl?.setValue('');
        markControl?.setValidators([Validators.required]);
        markControl?.enable({ emitEvent: false });
        if (markControl?.value === 0) {
          markControl?.setValue(0);
        }
      }
      markControl?.updateValueAndValidity({ emitEvent: false });
    });
  }

  checkIfAnyMarksEntered() {
    const stuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    let hasAnyMarks = false;

    stuArray.controls.forEach(studentControl => {
      const marksGroup = studentControl.get('marks') as FormGroup;
      this.dynamicHeads.forEach(head => {
        const markValue = marksGroup.get(head.code)?.value;
        if (markValue !== null && markValue !== '' && markValue !== undefined) {
          hasAnyMarks = true;
        }
      });
    });

    this.allMarksNull = !hasAnyMarks;
  }

  onStatusChange(selectedStatus: string, studentIndex: number, headCode: string) {
    const stuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;

    if (selectedStatus === 'AB') {
      marksGroup.get(headCode)?.clearValidators();
      marksGroup.get(headCode)?.setValue(0);
    } else {
      marksGroup.get(headCode)?.setValidators([Validators.required]);
    }
    marksGroup.get(headCode)?.updateValueAndValidity();
  }

  fetchStatus() {
    this.spinner.show();
    const payload = { CdType: 'PRST' };
    this.statusList = [];
    this.filteredStatusList = [];
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.statusList = res.data;
        this.filteredStatusList = this.statusList.slice();
      }
    });
  }

  keypress() {
    this.spinner.show();
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      this.ShowTable();
    }, 1000);
  }

  downloadPracticalMarksReportPDF(): void {
    if (!this.Table || !this.headcode || !this.pracEsId) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: "Please load practical marks data first!",
        title: "Alert",
        icon: "fas fa-close"
      });
      return;
    }

    const formData = this.PracticalMarksForm.value;
    const reportPayload = {
      SessionId: formData.SessionId,
      EmId: formData.EmId,
      CoCode: formData.course,
      CgCode: formData.college,
      EsId: formData.EsParentId,
      StrId: formData.Branch || 0,
      Batch: this.headcode,
      Preview: 0
    };

    let jsonString = JSON.stringify(reportPayload);

    const filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) || 0,
      "RptCode": 19,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] || 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": 0,
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": reportPayload.SessionId,
      "Extra1": jsonString,
      "Mode": true
    };
    this.reportService.generateHbsReport(filter)
  }

  previewPracticalMarksReport(): void {
    if (!this.Table || !this.headcode || !this.pracEsId) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: "Please load practical marks data first!",
        title: "Alert",
        icon: "fas fa-close"
      });
      return;
    }

    const formData = this.PracticalMarksForm.value;
    const reportPayload = {
      SessionId: formData.SessionId,
      EmId: formData.EmId,
      CoCode: formData.course,
      CgCode: formData.college,
      EsId: formData.EsParentId,
      StrId: formData.Branch || 0,
      Batch: this.headcode,
      Preview: 1
    };

    let jsonString = JSON.stringify(reportPayload);

    const filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) || 0,
      "RptCode": 19,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] || 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": 0,
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": reportPayload.SessionId,
      "Extra1": jsonString,
      "Mode": false
    };
    this.reportService.generateHbsReport(filter)
  }

  getStudentTotalMarks(studentIndex: number): number {
    const stuArray = this.PracticalMarksForm.get('StuArray') as FormArray;
    if (!stuArray || studentIndex >= stuArray.length) return 0;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;
    let total = 0;
    this.dynamicHeads.forEach(head => {
      const val = marksGroup.get(head.code)?.value;
      if (val !== null && val !== undefined && val !== '') {
        const num = Number(val);
        if (!isNaN(num)) total += num;
      }
    });
    return total;
  }

  // ==================================================================
  // AUTO-SELECT CHAIN
  // ==================================================================

  private tryAutoSelectSession() {
    if (!this.autoSelectMode) return;
    const sid = this.routeParams['SessionId'];
    if (!sid || !this.sessionList || !this.sessionList.length) return;

    const found = this.sessionList.find((s: any) => String(s.SnNo) === String(sid));
    if (found) {
      this.sessionList = [found];
      this.SessionFilterList = [found];
      this.PracticalMarksForm.patchValue({ SessionId: found.SnNo });
      this.getCourse(found.SnNo);
    } else {
      this.autoSelectMode = false;
    }
  }

  private tryAutoSelectCourse() {
    if (!this.autoSelectMode) return;

    const coCode = this.routeParams['CoCode'];
    const coName = this.routeParams['CoName'];

    if ((!coCode && !coName) || !this.CourseList || !this.CourseList.length) {
      this.autoSelectMode = false;
      return;
    }

    const found = this.CourseList.find((c: any) => {
      if (coCode && String(c.CoCode) === String(coCode)) return true;
      if (coName && String(c.CoName) === String(coName)) return true;
      return false;
    });

    if (found) {
      this.CourseList = [found];
      this.filteredListCourse = [found];
      this.PracticalMarksForm.patchValue({ course: found.CoCode });
      this.getCollege(found);
    } else {
      this.autoSelectMode = false;
    }
  }

  private tryAutoSelectCollege(item?: any) {
    if (!this.autoSelectMode) return;
    const cgCode = this.routeParams['CgCode'];

    if (cgCode && this.collegeList && this.collegeList.length) {
      const found = this.collegeList.find((c: any) => String(c.CgCode) === String(cgCode));
      if (found) {
        this.collegeList = [found];
        this.filteredCollegeList = [found];
        this.PracticalMarksForm.patchValue({ college: found.CgCode });
      }
    }

    if (item) {
      this.getExamList(item);
    } else {
      this.autoSelectMode = false;
    }
  }

  private tryAutoSelectExam() {
    if (!this.autoSelectMode) return;
    const emId = this.routeParams['EmId'];
    if (!emId || !this.examList || !this.examList.length) {
      this.autoSelectMode = false;
      return;
    }

    const found = this.examList.find((e: any) => String(e.EmId) === String(emId));
    if (found) {
      this.examList = [found];
      this.filteredListExam = [found];
      this.PracticalMarksForm.patchValue({ EmId: found.EmId });
      this.getSubject(found);
    } else {
      this.autoSelectMode = false;
    }
  }

  private tryAutoSelectBranch() {
    if (!this.autoSelectMode) return;
    const strId = this.routeParams['StrId'];
    if (!strId || !this.BranchList || !this.BranchList.length) {
      this.autoSelectMode = false;
      return;
    }

    const found = this.BranchList.find((b: any) => String(b.StrId) === String(strId));
    if (found) {
      this.BranchList = [found];
      this.filteredListBranch = [found];
      this.PracticalMarksForm.patchValue({ Branch: found.StrId });
      this.getStr(found);
    } else {
      this.autoSelectMode = false;
    }
  }

  private tryAutoSelectSubject() {
    if (!this.autoSelectMode) return;
    const esId = this.routeParams['EsId'];
    if (!esId || !this.subjectList || !this.subjectList.length) {
      this.autoSelectMode = false;
      return;
    }

    const found = this.subjectList.find((s: any) =>
      String(s.EsId) === String(esId) ||
      String(s.EsPSubId) === String(esId)
    );

    this.autoSelectMode = false;

    if (found) {
      this.subjectList = [found];
      this.filteredsubjectList = [found];
      this.subjectClick(found);
    }
  }

  private tryAutoSelectBatch() {
    if (!this.autoSelectBatchName) return;
    if (!this.HeadList || !this.HeadList.length) {
      this.autoSelectBatchName = '';
      return;
    }

    const target = String(this.autoSelectBatchName).trim().toLowerCase();

    const found = this.HeadList.find((b: any) => {
      const name = String(
        b.PbdBatchName ?? b.BatchName ?? b.PtBatchName ?? ''
      ).trim().toLowerCase();
      return name === target;
    });

    this.autoSelectBatchName = '';

    if (found) {
      this.HeadList = [found];
      this.filteredListHead = [found];
      this.PracticalMarksForm.controls['EsId'].setValue(found.PbdBatchName);

      this.getHeadCode(found);
    }
  }
}